// Single source of truth for BizPulseAI subscription plans.
// Both the landing-page pricing section and the dedicated /pricing page
// read from this file, so edits here are reflected everywhere.
//
// NOTE ON POSITIONING (Feb 2026):
//   BizPulseAI is not sold as software — it is sold as a complete AI Growth
//   Platform for independent consultants and boutique consulting firms.
//   Each plan therefore has an outcome-focused `title` alongside the short
//   `name` (which the UI still renders as an overline for continuity).
//   `id`, `monthly`, `lifetime`, `popular`, `ctaLabel` remain UNCHANGED so
//   billing, plan matching and Paddle checkout keep working exactly as-is.

export const PLANS = [
  {
    id: "starter",
    name: "Starter",
    title: "Launch Your Consulting Business",
    tagline: "For independent consultants launching their consulting practice.",
    monthly: 27,
    lifetime: 197,
    ctaLabel: "Get Starter",
    features: [
      "Launch your first Business Growth Discovery™",
      "Capture qualified consulting leads",
      "Generate Executive Growth Reports",
      "Share branded assessment links",
      "Book discovery meetings",
      "Basic follow-up tools",
      "Community support",
    ],
  },
  {
    id: "professional",
    name: "Professional",
    title: "Grow Your Consulting Business",
    tagline: "Everything needed to build a predictable consulting pipeline.",
    monthly: 47,
    lifetime: 297,
    popular: true,
    ctaLabel: "Get Professional",
    features: [
      "Unlimited Growth Campaigns",
      "Proposal Builder",
      "AI Executive Growth Reports",
      "LinkedIn Content Generator",
      "Business Benchmarking",
      "Nurture Campaigns",
      "Marketing Assets",
      "Multi-country assessments",
      "Priority Support",
    ],
  },
  {
    id: "enterprise",
    name: "Enterprise",
    title: "Scale Your Consulting Firm",
    tagline: "A premium, guided onboarding experience for consulting firms.",
    monthly: 77,
    lifetime: 497,
    ctaLabel: "Get Enterprise",
    features: [
      "Guided platform setup",
      "Branded Consultant Platform",
      "White-labelled reports",
      "Team workspace",
      "Custom branding",
      "Priority onboarding",
      "Dedicated support",
      "Future enterprise capabilities",
    ],
  },
];

export default PLANS;
